import { useCallback, useState } from "react";
import "../../styles/tableEditing/highlightableColumnEditor.css";
import {
  ColumnEditor,
  ColumnEditorProps,
} from "../dlfEditing/column/ColumnEditor";
import { useColumnHighlight } from "../hooks/dlfEditing/useColumnHighlight";

export { HighlightableColumnEditor };

type Props = {
  showColumn: boolean;
  highlightKey: string;
  onHighlightChange?: VoidFunction;
} & ColumnEditorProps;

const HighlightableColumnEditor = (props: Props) => {
  // console.log(`Rendering ${props.matcher.columnName}`);
  const [leftXPercent, setLeftXPercent] = useState<number>(
    props.matcher.columnSection.leftXPercent,
  );
  const [rightXPercent, setRightXPercent] = useState<number>(
    props.matcher.columnSection.rightXPercent,
  );

  const onRangeChange = useCallback(() => {
    props.matcher.showColumn = true;
    props.onRangeChange && props.onRangeChange();
  }, [props.onRangeChange]);
  const onRangeMove = useCallback(() => {
    props.matcher.showColumn = true;
    // console.log(`onRangeMove ${props.matcher.columnName}`);
    // console.log(props.matcher.columnSection.leftXPercent, leftXPercent, props.matcher.columnSection.rightXPercent, rightXPercent);
    setLeftXPercent(props.matcher.columnSection.leftXPercent);
    setRightXPercent(props.matcher.columnSection.rightXPercent);
  }, [props.onRangeMove]);

  useColumnHighlight(
    props.index ?? 0,
    props.highlightKey,
    leftXPercent,
    rightXPercent,
    props.showColumn,
  );

  // TODO: remove div.highlightableColumnEditor
  return (
    <div className={"highlightableColumnEditor"}>
      <ColumnEditor
        {...props}
        key={undefined}
        onRangeMove={onRangeMove}
        onRangeChange={onRangeChange}
        onClickLabel={() => {
          props.matcher.showColumn = !props.matcher.showColumn;
          props.onHighlightChange && props.onHighlightChange();
          props.onClickLabel && props.onClickLabel();
        }}
      />
    </div>
  );
};
